import { useEffect, useState } from "react";
import { fetchMeetingData } from "../api/meetingKioskApi";
import type { MeetingData } from "../types";

interface UseKioskDataResult {
  data: MeetingData | null;
  setData: React.Dispatch<React.SetStateAction<MeetingData | null>>;
  loadError: string | null;
}

export function useKioskData(dataUrl: string): UseKioskDataResult {
  const [data, setData] = useState<MeetingData | null>(null);
  const [loadError, setLoadError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchMeetingData(dataUrl)
      .then((d) => {
        if (!cancelled) setData(d);
      })
      .catch((err) => {
        if (!cancelled) setLoadError(String(err?.message ?? err));
      });
    return () => {
      cancelled = true;
    };
  }, [dataUrl]);

  return { data, setData, loadError };
}
